import { put, call, takeLatest, select } from 'redux-saga/effects';
import {
  updatePendingPrivateInquirySuccessAction,
  setPendingPrivateInquiryCountAction,
  setPendingPrivateInquiryIsLoadingAction,
  getPendingPrivateInquiriesSuccessAction,
  getSingleSupplierPrivateInquirySuccessAction,
  deleteSingleArtisanPrivateInquirySuccessAction,
  moderateCreateSupplierPrivateInquirySuccessAction,
} from './Actions';
import { push } from 'react-router-redux';
import {
  errorNotificationFromError,
  newSuccessNotificationAction,
} from '../../notifications/Actions';
import { authUserIdSelector } from '../../auth/Selectors';

import { actions } from './Reducer';
import * as api from './Api';
import { func } from 'prop-types';

function* getPendingPrivateinquiries({ payload }) {
  const defData = {
    offset: 0,
    size: 10,
    sort: 'createdAt',
    searchTerm: '',
    dir: 'asc',
    filterBy: [{"rejected": false}],
    filterCountry: '',
  };

  const body = { ...defData, ...payload };

  try {
    yield put(setPendingPrivateInquiryIsLoadingAction(true));
    const response = yield call(api.getPrivateInquiries, body);
    const { data } = response;
    const { content, count } = data;

    yield put(getPendingPrivateInquiriesSuccessAction(content));
    yield put(setPendingPrivateInquiryCountAction(count));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingPrivateInquiryIsLoadingAction(false));
  }
}

function* updatePendingPrivateinquiry({ payload }) {
  const moderatorID = yield select(authUserIdSelector);
  const defData = {
    moderatorID,
  };

  const body = { ...defData, ...payload };

  try {
    yield put(setPendingPrivateInquiryIsLoadingAction(true));
    yield call(api.updatePrivateInquiry, body);
    yield put(
      updatePendingPrivateInquirySuccessAction(body.moderationRecordID)
    );
    yield put(newSuccessNotificationAction('Inquiry Moderated'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingPrivateInquiryIsLoadingAction(false));
  }
}

function* getSingleSupplierPrivateInquiry({ payload }) {
  const id = payload;
  try {
    yield put(setPendingPrivateInquiryIsLoadingAction(true));
    const response = yield call(api.getSingleSupplierPrivateInquiry, id);

    const { data } = response;
    yield put(getSingleSupplierPrivateInquirySuccessAction(data));
      yield put(newSuccessNotificationAction('Inquiry Deleted'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingPrivateInquiryIsLoadingAction(false));
  }
}

function* deleteSinglePendingSupplierPrivateInquiry({ payload }) {
  const id = payload;
  try {
    yield put(setPendingPrivateInquiryIsLoadingAction(true));

    yield call(api.rejectSingleArtisanPrivateInquiry, id);
    yield put(deleteSingleArtisanPrivateInquirySuccessAction(id));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingPrivateInquiryIsLoadingAction(false));
  }
}

function* moderateCreatePrivateSupplierInquiry({ payload , mode}) {
  const id = payload;
  console.log(payload);
  try {
    yield put(setPendingPrivateInquiryIsLoadingAction(true));
    if (mode === 'update') {
  const response = yield call(api.moderateUpdateSupplierInquiry, id);
    const { data } = response;
    yield put(moderateCreateSupplierPrivateInquirySuccessAction(id));
    yield put(newSuccessNotificationAction('Inquiry Update Moderated'));
    yield put(push('/suppliers-moderation/private-inquiry'));
    } else {

  const response = yield call(api.moderateCreateSupplierInquiry, id);
    const { data } = response;
    yield put(moderateCreateSupplierPrivateInquirySuccessAction(id));
    yield put(newSuccessNotificationAction('Inquiry Moderated'));
    yield put(push('/suppliers-moderation/private-inquiry'));

    }
  
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingPrivateInquiryIsLoadingAction(false));
  }
}

export default function*() {
  yield takeLatest(
    actions.GET_PENDING_SUPPLIERS_PRIVATE_INQUIRIES,
    getPendingPrivateinquiries
  );

  yield takeLatest(
    actions.UPDATE_PENDING_SUPPLIER_PRIVATE_INQUIREY,
    updatePendingPrivateinquiry
  );
  yield takeLatest(
    actions.GET_SINGLE_SUPPLIER_PRIVATE_INQUIRY,
    getSingleSupplierPrivateInquiry
  );
  yield takeLatest(
    actions.DELETE_SINGLE_SUPPLIER_PRIVATE_INQUIRY,
    deleteSinglePendingSupplierPrivateInquiry
  );
  yield takeLatest(
    actions.MODERATE_CREATE_SUPPLIER_PRIVATE_INQUIRY,
    moderateCreatePrivateSupplierInquiry
  );
}
